export class BillingAddress {
  ID: number;
  Country: string;
  PostCode: string;
  City: string;
  Street: string;
  StreetNumber: string;
}
